import React from 'react';
import { C, storage } from '../constants';
import {
  CATEGORIAS, productoPorSku, ORIGEN_LABEL, fmtCOP,
  lineaPrecioTienda, totalCarritoTienda,
  buscarProductos, mezclarCatalogoVivo, setCategorias,
  flagsDocsProducto, urlDocProducto, enunciadoCertProducto,
} from '../services/productos';
import { currentClaims, getToken } from '../services/auth';
import { useDescuentoTecnico } from '../services/descuento-tecnico';
import { crearPedido, guardarPedidoLocal, listarMisPedidosVivos, ESTADO_PEDIDO_LABEL } from '../services/pedidos';
import { listarMediosPago, crearCheckoutTienda, confirmarRetornoPago, urlDeCheckout, opcionesDeRecaudo } from '../services/pagos';
import MedioAnclado from './MedioAnclado';
import PagoQr from './PagoQr';
import { claveTienda, qrVivo, guardarQrVivo, mensajeQrVivo } from '../services/qr-vivo';
import { hubGet } from '../services/hub';

function DocsProducto({ p }) {
  const flags = flagsDocsProducto(p);
  const ficha = flags.ficha ? urlDocProducto(p, 'ficha') : null;
  const manual = flags.manual ? urlDocProducto(p, 'manual') : null;
  if (!ficha && !manual) {
    return (
      <p style={{ margin: '12px 0 0', fontSize: 12, color: C.muted }}>
        Ficha y manual cuando el proveedor o el admin los carguen.
      </p>
    );
  }
  return (
    <div style={{ margin: '12px 0 0', display: 'flex', flexWrap: 'wrap', gap: 8 }}>
      {ficha && (
        <a href={ficha} download={flags.ficha_nombre || 'ficha.pdf'} className="sh-doc-link">
          Descargar ficha
        </a>
      )}
      {manual && (
        <a href={manual} download={flags.manual_nombre || 'manual.pdf'} className="sh-doc-link">
          Descargar manual
        </a>
      )}
    </div>
  );
}

function PrecioVista({ lin }) {
  if (lin.preferencial && lin.lista != null && lin.unitario != null && lin.unitario !== lin.lista) {
    return (
      <div className="precio">
        <s>{fmtCOP(lin.lista)}</s>
        {fmtCOP(lin.unitario)}
        <span className="meta"> −{lin.descuentoPct}%</span>
      </div>
    );
  }
  return <div className="precio">{fmtCOP(lin.lista)}</div>;
}

function Card({ p, lin, onOpen }) {
  return (
    <button type="button" className="sh-store-card" onClick={() => onOpen(p)}>
      <div className="sh-store-card-img">
        <img src={p.img || '/tienda/prod-panel.jpg'} alt="" />
        {p.destacado && <span className="sh-store-badge">Nuevo</span>}
        <span className="sh-store-card-hover">Ver producto</span>
      </div>
      <div className="sh-store-card-body">
        <div className="marca">{p.marca}</div>
        <div className="nombre">{p.nombre}</div>
        <PrecioVista lin={lin} />
        <div className="meta">{p.ficha?.stock || 'sin inventario'}</div>
      </div>
    </button>
  );
}

function Ficha({ p, lin, onClose, onAdd }) {
  const f = p.ficha || {};
  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,22,32,.62)', zIndex: 200 }} />
      <div role="dialog" aria-modal="true" style={{
        position: 'fixed', zIndex: 201, top: 0, right: 0, height: '100vh',
        width: 'min(980px, 100vw)', background: C.card, color: C.heading,
        borderLeft: `1px solid ${C.border}`, boxShadow: '-16px 0 40px rgba(0,0,0,.35)', overflowY: 'auto',
      }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1.15fr) minmax(280px,.85fr)' }} className="sh-ficha-grid">
          <div style={{ background: C.card2, minHeight: 320 }}>
            <img src={p.img || '/tienda/prod-panel.jpg'} alt={p.nombre} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', minHeight: 320 }} />
          </div>
          <div style={{ padding: '28px 26px 32px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
              <div>
                <div style={{ fontSize: 11, letterSpacing: '.12em', textTransform: 'uppercase', color: C.muted }}>{p.marca}</div>
                <h2 style={{ margin: '6px 0 10px', fontSize: 26, fontWeight: 600, letterSpacing: '-.03em', lineHeight: 1.15, color: C.heading }}>{p.nombre}</h2>
              </div>
              <button type="button" onClick={onClose} aria-label="Cerrar" style={{ width: 32, height: 32, border: 0, background: 'transparent', fontSize: 22, cursor: 'pointer', color: C.muted }}>×</button>
            </div>
            <div style={{ fontSize: 18, fontVariantNumeric: 'tabular-nums', marginBottom: 16, color: C.heading }}>
              {lin.preferencial && lin.lista !== lin.unitario ? <><s style={{ color: C.muted, marginRight: 8 }}>{fmtCOP(lin.lista)}</s>{fmtCOP(lin.unitario)}</> : fmtCOP(lin.lista)}
            </div>
            <p style={{ margin: '0 0 18px', fontSize: 14, lineHeight: 1.55, color: C.text }}>{p.desc}</p>
            <dl style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px 16px', margin: '0 0 22px', fontSize: 13 }}>
              {f.stock && <div><dt style={{ color: C.muted, fontSize: 11, letterSpacing: '.08em', textTransform: 'uppercase' }}>Disponibilidad</dt><dd style={{ margin: '3px 0 0' }}>{f.stock}</dd></div>}
              {f.envio && <div><dt style={{ color: C.muted, fontSize: 11, letterSpacing: '.08em', textTransform: 'uppercase' }}>Despacho</dt><dd style={{ margin: '3px 0 0' }}>{f.envio}</dd></div>}
              {f.garantia && <div><dt style={{ color: C.muted, fontSize: 11, letterSpacing: '.08em', textTransform: 'uppercase' }}>Garantía</dt><dd style={{ margin: '3px 0 0' }}>{f.garantia}</dd></div>}
              {f.potencia && <div><dt style={{ color: C.muted, fontSize: 11, letterSpacing: '.08em', textTransform: 'uppercase' }}>Potencia</dt><dd style={{ margin: '3px 0 0' }}>{f.potencia}</dd></div>}
            </dl>
            <button type="button" onClick={() => onAdd(p.sku)} style={{
              width: '100%', background: C.teal, color: C.heading, border: 0,
              padding: '14px 16px', fontWeight: 650, fontSize: 13, letterSpacing: '.08em',
              textTransform: 'uppercase', cursor: 'pointer', borderRadius: 8,
            }}>Añadir</button>
            <DocsProducto p={p} />
            <p style={{ margin: '14px 0 0', fontSize: 11.5, color: C.muted }}>SKU {p.sku} · {ORIGEN_LABEL[p.origen] || p.origen}{p.modelo ? ` · ${p.modelo}` : ''}</p>
          </div>
        </div>
        {(p.specs || []).length > 0 && (
          <div style={{ padding: '8px 26px 32px', borderTop: `1px solid ${C.border}` }}>
            <div style={{ fontSize: 11, letterSpacing: '.14em', textTransform: 'uppercase', margin: '16px 0 10px', color: C.muted }}>Ficha técnica</div>
            <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'grid', gap: 6 }}>
              {(p.specs || []).map((s, i) => (
                <li key={i} style={{ fontSize: 14, borderBottom: `1px solid ${C.border}`, padding: '6px 0', color: C.text }}>{s}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <style>{`@media (max-width:720px){ .sh-ficha-grid{ grid-template-columns:1fr !important; } }`}</style>
    </>
  );
}

export default function Tienda({ go }) {
  const [cat, setCat] = React.useState('');
  const [sub, setSub] = React.useState('');
  const [q, setQ] = React.useState('');
  const [orden, setOrden] = React.useState('destacado');
  const [sel, setSel] = React.useState(null);
  const [openCart, setOpenCart] = React.useState(false);
  const [cart, setCart] = React.useState(() => { try { const r = storage.get('sh:cart'); return r?.value ? JSON.parse(r.value) : {}; } catch { return {}; } });
  const [okMsg, setOkMsg] = React.useState('');
  const [errPago, setErrPago] = React.useState('');
  const [pagando, setPagando] = React.useState(false);
  const [medios, setMedios] = React.useState([]);
  const [medio, setMedio] = React.useState('pse');
  const [documento, setDocumento] = React.useState('');
  const [manual, setManual] = React.useState(null);
  // Cuánto cuesta cobrar por el medio elegido. El ruteo por costo decide solo; mostrarlo es lo
  // que impide que la decisión sea invisible para quien paga y para quien vende.
  const [recaudo, setRecaudo] = React.useState(null);
  const [pedidos, setPedidos] = React.useState([]);
  const [tick, setTick] = React.useState(0);
  const [categorias, setCats] = React.useState(CATEGORIAS);
  const claims = currentClaims();
  const email = (claims?.email || '').toLowerCase().trim();
  // 🔴 Quién compra con precio de técnico lo dice el SERVIDOR, con la misma función que sella el
  // cobro. Antes salía de `isTecnico(claims)` —claims sin firma validada— y el checkout cobraba
  // lista: la pantalla prometía un precio que el pedido no hacía. Ver services/descuento-tecnico.js.
  const descTec = useDescuentoTecnico();
  const esTec = descTec.aplica;
  const precioOpts = { esTecnico: esTec, pct: descTec.pct };
  const productos = buscarProductos({ categoria: cat, sub, q, orden });
  void tick;
  const saveCart = (c) => { setCart(c); try { storage.set('sh:cart', JSON.stringify(c)); } catch { /* noop */ } };
  const addToCart = (sku) => { saveCart({ ...cart, [sku]: (cart[sku] || 0) + 1 }); setOpenCart(true); };
  const setQty = (sku, n) => { const c = { ...cart }; if (n <= 0) delete c[sku]; else c[sku] = n; saveCart(c); };
  const cartItems = Object.entries(cart).map(([sku, qty]) => ({ p: productoPorSku(sku), qty })).filter((x) => x.p);
  const cartCount = cartItems.reduce((s, x) => s + x.qty, 0);
  const cartTotal = totalCarritoTienda(cartItems, precioOpts);
  const cartTotalLista = cartItems.reduce((s, x) => s + (x.p.precioRef || 0) * x.qty, 0);

  React.useEffect(() => {
    hubGet('tienda/catalogo').then((r) => {
      const rows = r?.productos || r?.productos_proveedores;
      if (Array.isArray(r?.categorias) && r.categorias.length) {
        setCategorias(r.categorias);
        setCats(r.categorias);
      }
      if (Array.isArray(rows)) {
        mezclarCatalogoVivo(rows);
        setTick((n) => n + 1);
      }
    }).catch(() => {});
  }, []);
  React.useEffect(() => {
    listarMediosPago().then((r) => {
      // El QR no va en este selector: es «Otros medios». El QR se ofrece primero en `PagoQr`.
      const ms = Array.isArray(r?.medios) ? r.medios.filter((m) => m.habilitado && m.tipo !== 'qr') : [];
      setMedios(ms);
      const primero = ms.find((m) => m.listo);
      if (primero) setMedio(primero.clave);
    }).catch(() => setMedios([]));
  }, []);
  React.useEffect(() => {
    listarMisPedidosVivos(email).then(setPedidos).catch(() => setPedidos([]));
  }, [email]);
  // 🔗 `?view=tienda&sku=…` abre la ficha de ESE producto. Es el enlace que Alex manda por WhatsApp
  // (15-sep): sin esto, el cliente aterrizaba en la Tienda entera y tenía que buscar lo que ya le
  // habían nombrado. El catálogo vivo llega después del primer render, por eso depende de `tick`.
  //
  // 🪤 Se abre UNA sola vez: sin el guardián, cerrar la ficha la volvería a abrir en el siguiente
  // render y el cliente no podría salir de ese producto.
  const abiertoPorEnlace = React.useRef(false);
  React.useEffect(() => {
    if (abiertoPorEnlace.current) return;
    const sku = new URLSearchParams(window.location.search).get('sku');
    if (!sku) return;
    const p = productoPorSku(sku);
    if (p) { abiertoPorEnlace.current = true; setSel(p); }
  }, [tick]);
  React.useEffect(() => {
    // La comisión depende del MONTO: el mismo medio puede ser el más barato en un ticket y el
    // más caro en otro (cargo fijo vs porcentual). Por eso se consulta con el total del carrito.
    if (!(cartTotal > 0)) { setRecaudo(null); return undefined; }
    let vivo = true;
    opcionesDeRecaudo({ monto: cartTotal, medio })
      .then((r) => { if (vivo) setRecaudo(r?.elegida || null); })
      .catch(() => { if (vivo) setRecaudo(null); });
    return () => { vivo = false; };
  }, [cartTotal, medio]);
  React.useEffect(() => {
    const qs = new URLSearchParams(window.location.search);
    const ref = qs.get('ref') || qs.get('id') || qs.get('referencia');
    if (qs.get('pago') !== 'ok' || !ref) return;
    confirmarRetornoPago(ref).then((r) => {
      if (r?.pedido) {
        guardarPedidoLocal({ ...r.pedido, fecha: r.pedido.creado_en });
        setOkMsg(r.pedido.estado === 'pagado'
          ? `Pago recibido · pedido ${r.pedido.id}`
          : `Checkout cerrado · pedido ${r.pedido.id}.`);
        listarMisPedidosVivos(email).then(setPedidos).catch(() => {});
      }
    }).catch(() => {});
  }, [email]);

  // QR Bancolombia PRIMERO (dueño, 13-oct-2026): «Pagar» abre el selector; «Otros medios» sigue
  // por el checkout de siempre. Con `conQr` el servidor no abre pantalla de Wompi: devuelve el
  // pedido y el QR se pinta acá (`PagoQr`).
  const [eligiendo, setEligiendo] = React.useState(false);
  const checkout = async (conQr = false) => {
    if (!cartItems.length) return conQr ? { error: 'La bolsa está vacía.' } : undefined;
    // 🔴 Un QR vivo de esta misma bolsa: se retoma (si se pide QR) o se frena (si se pide otro
    // medio). Pagar por otro lado mientras el QR sigue cobrable es pagar dos veces.
    const clave = claveTienda(cartItems.map((x) => x.p.sku));
    const vivo = qrVivo(clave);
    if (vivo) {
      if (conQr) return { ref: vivo.ref, vence: vivo.vence };
      setErrPago(mensajeQrVivo(vivo));
      return undefined;
    }
    setPagando(true); setErrPago(''); setManual(null);
    const items = cartItems.map((x) => {
      const lin = lineaPrecioTienda(x.p.precioRef, precioOpts);
      return { sku: x.p.sku, nombre: x.p.nombre, precioRef: lin.unitario, qty: x.qty };
    });
    const retorno = `${window.location.origin}${window.location.pathname}?pago=ok`;
    try {
      const r = await crearCheckoutTienda({
        // 🔑 El token va en el CUERPO (hubPost no manda cabeceras propias, igual que en las rutas
        // de administración): es lo que le permite al servidor aplicar el precio de técnico sobre
        // el precio que él mismo selló, en vez de creerle al `precioRef` del navegador.
        items, email, nombre: claims?.name || '', documento, moneda: 'COP', retorno_url: retorno,
        ...(conQr ? { qr: true, acepto_terminos: true } : { medio }),
        token: getToken() || undefined,
      });
      const ref = r.referencia || r.pedido_id;
      guardarPedidoLocal({
        // 🔑 El total y los ítems que se guardan son los que devolvió el servidor —los SELLADOS—,
        // no los del carrito: desde que el precio lo pone el servidor, el número del navegador es
        // una estimación. Si la respuesta no los trae, se cae al carrito para no dejar el
        // historial vacío.
        id: ref, email, nombre: claims?.name || '',
        items: Array.isArray(r.items) && r.items.length ? r.items : items,
        total: Number.isFinite(Number(r.total)) && Number(r.total) > 0 ? Number(r.total) : cartTotal,
        estado: r.pasarela === 'manual' ? 'solicitado' : 'confirmado', fecha: new Date().toISOString(),
      });
      const certs = Array.isArray(r.certificados) ? r.certificados : [];
      const notaCert = certs.length
        ? ` ${certs.map((c) => c.enunciado).join(' ')}`
        : '';
      if (conQr) {
        if (r.checkout?.tipo === 'qr') { guardarQrVivo(clave, ref, r.vence); saveCart({}); return { ref, vence: r.vence }; }
        return { error: 'No se pudo generar el QR. Paga con otro medio.' };
      }
      if (r.checkout?.tipo === 'manual') {
        setManual(r.checkout);
        setOkMsg(`Pedido ${ref}. Transfiere con esa referencia.${notaCert}`);
        return;
      }
      const urlRetorno = `${window.location.origin}${window.location.pathname}?pago=ok&ref=${encodeURIComponent(ref)}`;
      const url = urlDeCheckout(r.checkout, urlRetorno);
      if (url) { saveCart({}); window.location.href = url; return; }
      setErrPago('La pasarela no devolvió una URL de cobro.');
    } catch (e) {
      // Un QR que no se generó no es una «solicitud»: se dice y queda «Otros medios».
      if (conQr) return { error: (e && e.data && e.data.error) || (e && e.message) || 'No se pudo generar el QR. Paga con otro medio.' };
      // Un 409 del servidor (QR vigente, o ya pagado) no es una caída: no se deja como «solicitud».
      if (e && e.status === 409) { setErrPago((e.data && e.data.error) || e.message); return; }
      crearPedido({ items, email, nombre: claims?.name || '', total: cartTotal });
      setErrPago((e && e.message) || 'No se pudo iniciar el cobro. Quedó como solicitud.');
    } finally { setPagando(false); }
  };

  const titulo = cat ? (categorias.find((c) => c.id === cat)?.label || 'Todos') : (q ? 'Resultados' : 'Todos');
  const hijos = cat ? (categorias.find((c) => c.id === cat)?.hijos || []) : [];

  return (
    <div className="sh-store al-content">
      <PagoQr
        abierto={eligiendo}
        onOtrosMedios={() => { void checkout(false); }}
        onGenerarQr={() => checkout(true)}
        onPagado={() => {
          setOkMsg('Pago recibido. Te enviamos la factura al correo.');
          listarMisPedidosVivos(email).then(setPedidos).catch(() => {});
        }}
        onCerrar={() => setEligiendo(false)}
      />
      <div className="sh-plp">
        <header className="sh-plp-top">
          <div>
            <h1>{titulo}</h1>
            <div className="sh-plp-count">{productos.length} producto{productos.length === 1 ? '' : 's'}</div>
          </div>
          <div className="sh-plp-tools">
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar" aria-label="Buscar" />
            <select value={orden} onChange={(e) => setOrden(e.target.value)} aria-label="Ordenar">
              <option value="destacado">Ordenar</option>
              <option value="precio-asc">Precio: menor a mayor</option>
              <option value="precio-desc">Precio: mayor a menor</option>
              <option value="nombre">Nombre</option>
            </select>
            <button type="button" className="sh-plp-bag" onClick={() => setOpenCart(true)}>
              Bolsa{cartCount ? ` (${cartCount})` : ''}
            </button>
          </div>
        </header>

        {esTec && (
          <p style={{ margin: '14px 0 0', fontSize: 12.5, color: C.muted }}>
            Precio técnico −{descTec.pct}% sobre lista.
          </p>
        )}
        {okMsg && <p style={{ margin: '12px 0 0', fontSize: 13, color: C.green }}>{okMsg}</p>}

        <div className="sh-plp-body">
          <aside className="sh-plp-filters" aria-label="Filtrar">
            <h2>Filtrar</h2>
            <button type="button" className={!cat ? 'on' : ''} onClick={() => { setCat(''); setSub(''); }}>Todos</button>
            {categorias.map((cg) => (
              <button key={cg.id} type="button" className={cat === cg.id ? 'on' : ''}
                onClick={() => { setCat(cat === cg.id ? '' : cg.id); setSub(''); }}>
                {cg.label}
              </button>
            ))}
            {hijos.length > 0 && hijos.map((h) => (
              <button key={h.id} type="button" className={`sub${sub === h.id ? ' on' : ''}`}
                onClick={() => setSub(sub === h.id ? '' : h.id)}>
                {h.label}
              </button>
            ))}
            <div className="sh-plp-note">
              El surtido lo cargan el admin y los proveedores. El kit se arma en el cotizador.
              {typeof go === 'function' && (
                <button type="button" onClick={() => go('quoter')}> Modelar techo</button>
              )}
            </div>
          </aside>

          <div>
            <div className="sh-store-grid">
              {productos.map((p) => (
                <Card key={p.sku} p={p} lin={lineaPrecioTienda(p.precioRef, precioOpts)} onOpen={setSel} />
              ))}
            </div>
            {productos.length === 0 && (
              <p className="sh-store-empty">Nada con ese filtro. Prueba otra categoría o modela el techo.</p>
            )}
          </div>
        </div>
      </div>

      <footer className="sh-plp-foot">
        <span>Solar Hub · factura Alebas NIT 901.992.450-5</span>
        <span>Wompi · Rapyd · Bre-B · transferencia</span>
        <span>Stock real cuando el proveedor lo publique</span>
      </footer>

      {pedidos.length > 0 && (
        <section style={{ maxWidth: 1280, margin: '24px auto 0', padding: '0 28px', color: C.heading }}>
          <h2 style={{ margin: '0 0 10px', fontSize: 13, letterSpacing: '.12em', textTransform: 'uppercase', fontWeight: 650, color: C.muted }}>Pedidos</h2>
          <div style={{ display: 'grid', gap: 0 }}>
            {pedidos.slice(0, 8).map((pd) => (
              <div key={pd.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap', borderBottom: `1px solid ${C.border}`, padding: '10px 0' }}>
                <div style={{ fontSize: 13, color: C.text }}>
                  {(pd.items || []).reduce((s, i) => s + (i.qty || 0), 0)} · {(pd.items || []).map((i) => i.nombre).slice(0, 2).join(', ')}
                  <span style={{ color: C.muted }}> · {new Date(pd.fecha || pd.creado_en).toLocaleDateString('es-CO')}</span>
                </div>
                <span style={{ fontSize: 11, letterSpacing: '.06em', textTransform: 'uppercase', color: C.muted }}>{ESTADO_PEDIDO_LABEL[pd.estado] || pd.estado}</span>
              </div>
            ))}
          </div>
        </section>
      )}

      {sel && <Ficha p={sel} lin={lineaPrecioTienda(sel.precioRef, precioOpts)} onClose={() => setSel(null)} onAdd={(sku) => { addToCart(sku); setSel(null); }} />}

      {openCart && (
        <>
          <div onClick={() => setOpenCart(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,22,32,.55)', zIndex: 200 }} />
          <div role="dialog" aria-modal="true" style={{ position: 'fixed', zIndex: 201, top: 0, right: 0, height: '100vh', width: 'min(400px, 96vw)', background: C.card, color: C.heading, borderLeft: `1px solid ${C.border}`, boxShadow: '-16px 0 40px rgba(0,0,0,.35)', display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 20px', borderBottom: `1px solid ${C.border}` }}>
              <div style={{ fontSize: 15, fontWeight: 650, letterSpacing: '-.02em' }}>Bolsa{cartCount ? ` (${cartCount})` : ''}</div>
              <button type="button" onClick={() => setOpenCart(false)} aria-label="Cerrar" style={{ width: 32, height: 32, border: 0, background: 'transparent', fontSize: 22, cursor: 'pointer', color: C.muted }}>×</button>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', padding: 16, display: 'grid', gap: 12, alignContent: 'start' }}>
              {cartItems.length === 0 ? (
                <div style={{ fontSize: 13, color: C.muted, padding: 20 }}>La bolsa está vacía.</div>
              ) : cartItems.map(({ p, qty }) => (
                <div key={p.sku} style={{ display: 'flex', gap: 12, paddingBottom: 12, borderBottom: `1px solid ${C.border}` }}>
                  <img src={p.img} alt="" style={{ width: 72, height: 72, objectFit: 'cover', background: C.card2 }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: 500, color: C.heading }}>{p.nombre}</div>
                    <div style={{ fontSize: 12, color: C.muted, marginTop: 3 }}>{fmtCOP(lineaPrecioTienda(p.precioRef, precioOpts).unitario)}</div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <button type="button" onClick={() => setQty(p.sku, qty - 1)} style={{ width: 26, height: 26, border: `1px solid ${C.border}`, background: 'transparent', color: C.text, cursor: 'pointer' }}>−</button>
                    <span style={{ minWidth: 14, textAlign: 'center', fontSize: 13 }}>{qty}</span>
                    <button type="button" onClick={() => setQty(p.sku, qty + 1)} style={{ width: 26, height: 26, border: `1px solid ${C.border}`, background: 'transparent', color: C.text, cursor: 'pointer' }}>+</button>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ borderTop: `1px solid ${C.border}`, padding: 18 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12, fontSize: 15 }}>
                <span>{esTec ? 'Subtotal técnico' : 'Total'}</span>
                <span style={{ fontVariantNumeric: 'tabular-nums' }}>{fmtCOP(cartTotal)}</span>
              </div>
              {esTec && cartTotalLista > cartTotal && (
                <div style={{ fontSize: 12, color: C.muted, textDecoration: 'line-through', textAlign: 'right', marginTop: -8, marginBottom: 10 }}>{fmtCOP(cartTotalLista)}</div>
              )}
              <label style={{ display: 'block', fontSize: 11, letterSpacing: '.08em', textTransform: 'uppercase', color: C.muted, marginBottom: 4 }}>Cédula / NIT · obligatorio para la factura</label>
              <input value={documento} onChange={(e) => setDocumento(e.target.value)} placeholder="901992450-5" style={{ width: '100%', marginBottom: 10, border: 0, borderBottom: `1px solid ${C.border}`, padding: '8px 0', background: 'transparent', color: C.text, fontSize: 13 }} />
              {medios.length > 0 && (
                <select value={medio} onChange={(e) => setMedio(e.target.value)} style={{ width: '100%', marginBottom: 10, border: 0, borderBottom: `1px solid ${C.border}`, padding: '8px 0', background: 'transparent', color: C.text, fontSize: 13 }}>
                  {medios.map((m) => (
                    <option key={m.clave} value={m.clave} disabled={!m.listo}>{m.nombre}{m.listo ? '' : ' · sin llaves'}</option>
                  ))}
                </select>
              )}
              {/* Lo que cuesta cobrar por ese medio, ANTES de pagar — con la procedencia de la
                  tarifa. Una comisión de referencia presentada como si fuera del contrato es
                  ruteo de plata sin declarar. */}
              {recaudo && recaudo.comision > 0 && (
                <div style={{ fontSize: 11, color: C.muted, lineHeight: 1.45, marginBottom: 10 }}>
                  Costo de recaudo estimado: <strong style={{ color: C.text }}>{fmtCOP(recaudo.comision)}</strong>
                  {recaudo.procedencia === 'supuesto' ? ' · tarifa de referencia, no del contrato' : ' · tarifa del contrato'}
                </div>
              )}
              {/* Guardar la tarjeta para los próximos cobros. El número se tokeniza en el
                  navegador contra Wompi: al hub-api solo llega el token de un solo uso. */}
              {email && <MedioAnclado email={email} />}
              {manual && (
                <div style={{ fontSize: 12, lineHeight: 1.45, marginBottom: 10, color: C.text }}>
                  {manual.datos?.llave
                    ? <>Bre-B · {manual.datos.referencia}<br />Llave {manual.datos.llave} · {manual.datos.titular}</>
                    : <>Transferencia · {manual.datos?.referencia}<br />{manual.datos?.titular} · {manual.datos?.banco} {manual.datos?.numero}</>}
                </div>
              )}
              {cartItems.some(({ p }) => flagsDocsProducto(p).cert) && (
                <div style={{ fontSize: 12, lineHeight: 1.45, marginBottom: 10, color: C.text, background: `${C.teal}14`, border: `1px solid ${C.teal}44`, borderRadius: 8, padding: '8px 10px' }}>
                  {cartItems.map(({ p }) => enunciadoCertProducto(p)).filter(Boolean).map((t) => (
                    <div key={t}>{t}</div>
                  ))}
                </div>
              )}
              {errPago && <div style={{ fontSize: 12, color: C.red, marginBottom: 8 }}>{errPago}</div>}
              <button type="button" onClick={() => setEligiendo(true)} disabled={!cartItems.length || pagando || !documento.trim()} style={{
                width: '100%', background: cartItems.length ? C.teal : C.card2, color: cartItems.length ? C.heading : C.muted,
                border: 0, padding: 14, fontWeight: 650, fontSize: 12, letterSpacing: '.1em', textTransform: 'uppercase',
                cursor: cartItems.length && !pagando ? 'pointer' : 'default', borderRadius: 8,
              }}>
                {pagando ? 'Abriendo…' : (documento.trim() ? 'Pagar' : 'Falta cédula / NIT')}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
